import { BaseService } from "services/_baseService";

class LocationsAdminService extends BaseService<any> {
  constructor() {
    super(`locations`);
  }
}

export default new LocationsAdminService();
